<template>
  <b-form inline>
    <b-form-select class="mr-2"
    v-model="prioritat"
    :options="prioritats_select"
    size="sm">
    </b-form-select>
  </b-form>
</template>

<script>

export default {
  computed: {
    priorities () {
      return this.$store.state.priorities
    }
  },
  data () {
    return {
      prioritat: null,
      prioritats_select: []
    }
  },
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  methods: {
    updatePrioritiesSelect () {
      this.prioritats_select = this.priorities
        .map(prioritat => {
          if (prioritat.descripcio !== this.ticket.prioritat) {
            return {
              value: prioritat.id,
              text: prioritat.descripcio
            }
          } else {
            return {
              value: null,
              text: prioritat.descripcio,
              disabled: true,
              selected: true
            }
          }
        })
    }
  },
  created () {
    this.$store.dispatch('fetchPrioritats').then(() => this.updatePrioritiesSelect())
  },
  watch: {
    ticket: function () {
      this.prioritat = null
      this.updatePrioritiesSelect()
    },
    prioritat: function (newVal) {
      this.$emit('updatePriority', newVal)
    }
  }
}
</script>

<style scoped>
</style>
